import { SignUp } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";

import { Navigation } from "@/constants";

const APP_REDIRECT_URL = Navigation.ROUTES.APP.PAGE;

export default function Page() {
  const [searchParams] = useSearchParams();
  // Where they were going in the app - an invitation they were sent - once
  // signed up; a page of the app alone, never anywhere else.
  const asked = searchParams.get("redirect_url") ?? "";
  const redirectUrl =
    asked.startsWith(`${APP_REDIRECT_URL}/`) || asked === APP_REDIRECT_URL
      ? asked
      : APP_REDIRECT_URL;
  // The address an invitation was sent to, to sign up with.
  const emailAddress = searchParams.get("email_address");

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <SignUp
        path="/auth/sign-up"
        forceRedirectUrl={redirectUrl}
        fallbackRedirectUrl={redirectUrl}
        signInForceRedirectUrl={redirectUrl}
        initialValues={emailAddress ? { emailAddress } : undefined}
      />
    </div>
  );
}
